import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Главная',
    component: HomeView
  },
  {
    path: '/ekran',
    name: 'Выходные сведения',
    component: () => import(/* webpackChunkName: "about" */ '../views/EkranView.vue')
  },
  {
    path: '/drafters',
    name: 'От составителя',
    component: () => import(/* webpackChunkName: "about" */ '../views/DraftersView.vue')
  },
  // {
  //   path: '/about',
  //   name: 'Указатель',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/about/:family',
    name: 'Библиографический указатель',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { 
    path: '/404', 
    name: '404 Страница не найдена',
    component: NotFound 
  },
  { 
    path: '*', 
    redirect: '/404' 
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
